import {deslugify} from 'shared';

/**
 * Create a standardized document title
 * @param input page specific text to use
 * @param shouldUseExact should replace as whole title instead of injecting
 * @returns document title string
 */
export function makeDocumentTitle(
  input: string,
  shouldUseExact = false
): {title: string} {
  const decoded = decodeURIComponent(input);
  const title = deslugify(decoded);

  return {
    title: !shouldUseExact ? `${title} | Qii Studio` : input,
  };
}
